// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import Vant from "vant";
import "vant/lib/index.css";

import "mv-full-page/lib-dist/mv-full-page.css";
import MvFullPage from "mv-full-page";

import "@/assets/svgIcons";

import store from "./store/index.js";

import publicFun from "@/util/publicFun.js";
import aliOss from "@/util/aliOss.js";
import timeTask from '@/util/timerTask.js'
import cookiesModule from '@/util/cookiesModule.js'
import sessionStorageManage from '@/util/sessionStorageManage.js'
import localStorageModule from '@/util/localStorageModule.js'
import axios from './util/axios.js'

import VueI18n from "vue-i18n";
import zh from "./components/language/zh";
import en from "./components/language/en";

import * as filters from '@/util/filters.js'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.use(MvFullPage);
Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(publicFun);
Vue.use(aliOss);
Vue.use(timeTask);
Vue.use(cookiesModule);
Vue.use(sessionStorageManage);
Vue.use(localStorageModule);
Vue.use(axios);

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: sessionStorage.getItem("langType") || "zh", //从localStorage里获取用户中英文选择，没有则默认中文
  messages: {
    zh: zh,
    en: en
  }
});

Vue.config.productionTip = false;

Vue.prototype.$store = store;
window.$store = store

/* eslint-disable no-new */
// new Vue({
//   el: "#app",
//   router,
//   store,
//   i18n,
//   components: { App },
//   template: "<App/>"
// });

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js